export enum RELEASE_TYPE {
    unknown = -1,
    single = 1,
    album = 2,
    minialbum = 3,
  }
  
  export enum SUBSCRIPTION_TYPE {
    unknown = -1,
    all = 1,
    ad = 2,
    subscription = 3,
  }